<template>
    <div class="p-content-full-width grid">
        <cmp-to-top></cmp-to-top>

        <div class="grid--container">
            <div class="grid--row p-content-full-width--row">
                <div class="p-content-full-width--col grid--col">
                    <cmp-breadcrumbs :tree="routeData.breadcrumbs"></cmp-breadcrumbs>
                </div>
            </div>
            <div class="grid--row p-content-full-width--row">
                <div class="p-content-full-width--col grid--col">
                    <cmp-main :container="containers.main"></cmp-main>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import routeMixin from 'vue/mixins/route';

    export default {
        mixins: [routeMixin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?47d5d2a9